import { ref } from 'vue';
import { useRoute } from 'vue-router';
import { firstQueryValue } from './queryValue';
import useUpdateUrl from './useUpdateUrl';

interface SearchUrlSyncOptions {
  fields: readonly string[];
  defaultField: string;
  fieldQueryKey?: string;
}

export default function useSearchUrlSync(options: SearchUrlSyncOptions) {
  const { fields, defaultField, fieldQueryKey = 'searchField' } = options;
  const route = useRoute();
  const { updateUrl } = useUpdateUrl();

  const rawField = firstQueryValue(route.query[fieldQueryKey]);
  const searchFieldId = ref(rawField && fields.includes(rawField) ? rawField : defaultField);
  const searchTerm = ref(firstQueryValue(route.query.term) ?? '');

  const syncSearchUrl = (extraQuery: Record<string, string | number | undefined> = {}) => {
    const trimmed = searchTerm.value.trim();
    void updateUrl({
      search: trimmed,
      query: {
        ...(trimmed ? { [fieldQueryKey]: searchFieldId.value } : {}),
        ...extraQuery,
      },
    });
  };

  return { searchTerm, searchFieldId, syncSearchUrl };
}
